import React from 'react';
import PropTypes from 'prop-types';
import { IndexRoute, Redirect, Router, Route } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';
import { hot } from 'react-hot-loader';

import ActivityItemsList from './components/activities/ActivityItemsList';
import AppointmentListPage from './components/scheduling/AppointmentListPage';
import BulkFileWorkflowsList from './components/bulk_file_upload/BulkFileWorkflowsList';
import BulkFileWorkflow from './components/bulk_file_upload/BulkFileWorkflow';
import BlackbaudSkyConfig from './components/setup/BlackbaudSkyConfig';
import QuickbooksConfig from './components/setup/QuickbooksConfig';
import CommunicationPlanList from './components/communication_plans/CommunicationPlanList';
import ContactBillingTab from './components/billing/ContactBillingTab';
import Dashboard from './components/Dashboard/Dashboard';
import DelayedJobs from './components/delayed_jobs/DelayedJobs';
import MMSHistory from './components/communication/MMSHistory';
import MMSSetup from './components/communication/MMSSetup';
import EmailSnippetList from './components/communication/EmailSnippetList';
import LetterSnippetList from './components/communication/LetterSnippetList';
import MailingLabelSnippetList from './components/communication/MailingLabelSnippetList';
import MMSSnippetList from './components/communication/MMSSnippetList';
import Reindex from './components/Reindex/Reindex';
import Summary from './components/ContactRecord/Summary';
import WidgetSnippetList from './components/communication/WidgetSnippetList';
import BillingConfigPage from "./components/setup/BillingConfigPage";
import registeredComponent from "./utils/registeredComponent";
import OAuthConfig from './components/setup/OAuthConfig/OAuthConfig';
import GenderConfig from './components/setup/GenderConfig';
import ExportConfig from './components/setup/ExportConfig';
import ScheduledEmailsList from './components/setup/ScheduledEmailsList';
import EmailsList from './components/setup/EmailsList';
import EmailOpenRates from './components/setup/EmailOpenRates';
import MyReviews from './components/Review/MyReviews';
import ReviewSettings from './components/setup/Review/ReviewSettings';
import ApiOverview from './components/api/ApiOverview';
import CandidatesInReview from 'components/Review/CandidatesInReview';
import SftpListPage from './components/setup/sftp/SftpListPage';


import PaymentPlanPage from "./components/setup/PaymentPlan/PaymentPlanPage";


import StudentsListPage from './components/billing/StudentsListPage';
import AccountsListPage from './components/billing/AccountsListPage';

import LedgerItemList from './components/billing/LedgerItemList';
import InSchoolPayments from './components/billing/InSchoolPayments';
import BillingReports from './components/billing/BillingReports';

import globalHistory from 'shared_history';

import parentPortalRoutes from './parent_portal_routes';
import BillingCategoryReport from 'components/billing/BillingCategoryReport';
import BillingDashboard from 'components/billing/BillingDashboard';
import ProjectedIncomeReport from 'components/billing/ProjectedIncomeReport';
import RevenueRecognitionReport from 'components/billing/RevenueRecognitionReport';
import MonthlyIncrementalReport from 'components/billing/MonthlyIncrementalReport';
import BillingAgingReport from "components/billing/BillingAgingReport";
import BillingARReport from 'components/billing/BillingARReport';
import BillingCategoryPage from './components/setup/BillingCategoryPage';
import BillingImportJobHistory from './components/billing/BillingImportJobHistory';
import StripePayoutReport from './components/stripe_reports/StripePayoutReport';
import StripePayout from './components/stripe_reports/StripePayout';
import ManageSetupHome from './components/manageSetupHome/ManageSetupHome';
import ManageChecklistSchoolGroups from './components/ManageChecklistSchoolGroups/ManageChecklistSchoolGroups';
import ManageSharedPortalGroups from './components/ManageSharedPortalGroups/ManageSharedPortalGroups';
import SAPaymentsSetupPage from "components/payments/SAPaymentsSetupPage";
import UserJobPage from "components/UserJobs/UserJobsPage";
import CombinedFunnelReport from 'components/reporting/CombinedFunnelReport';
import ReaderReport from 'components/reporting/ReaderReport';
import ReaderScoresReport from './components/reporting/ReaderScoresReport';
import KeyFeatureReport from 'components/reporting/KeyFeatureReport';
import CombinedEnrollmentTotalsReport from 'components/reporting/CombinedEnrollmentTotalsReport';
import FormInbox from 'components/FormInbox/FormInbox';
import PowerSchoolContacts from './components/powerSchoolContacts/PowerSchoolContacts';
import CustomerLedger from 'components/setup/CustomerLedger';
import FeeManagementPage from './components/setup/FeeManagementPage';
import ListPageConfig from 'components/setup/ListPageConfig';
import DeletedContactPage from 'components/setup/DeletedContactPage';
import VeracrossConfig from 'components/setup/VeracrossConfig';
import ManageExternalApiCredentials from 'components/setup/ManageExternalApiCredentals';
import ClarityTuitionConfig from 'components/setup/ClarityTuitionConfig';
import ReviewTab from './components/ContactRecord/Review/ReviewTab';
import ReviewDocument from './components/ContactRecord/Review/ReviewDocument';
import ReviewCoverSheet from './components/ContactRecord/Review/ReviewCoverSheet';
import ReviewActivities from './components/ContactRecord/Review/ReviewActivities';
import ReviewSummary from './components/ContactRecord/Review/ReviewSummary';
import ReviewTestScores from './components/ContactRecord/Review/ReviewTestScores';
import DisputesList from './components/setup/DisputesList';
import TagListPage from "./components/Tagging/TagListPage";
import SavedSearchList from "./components/admin_portal/SavedSearchList";
import LeadSourceReport from "./components/reporting/LeadSourceReport";
import ContractFeesList from "./components/setup/ContractFeesList";
import SharedPortalConfig from "./components/setup/SharedPortalConfig";
import CrossApplicantsReport from "./components/reporting/CrossApplicantsReport";
import SharedPortalSherlock from './components/sherlock/SharedPortalSherlock';
import ManageRateCards from './components/ManageRateCards/ManageRateCards';
import GroupListPage from "./components/setup/Permissions/GroupListPage";
import AdminListPage from "./components/setup/Permissions/AdminListPage";
import SchoolYearConfigPage from './components/setup/SchoolYearConfigPage';
import LotteryConfigurationsIndex from './components/setup/lotteries/LotteryConfigurationsIndex';

class Routes extends React.Component {

  static contextTypes = {
    store: PropTypes.object
  };

  render () {
    const { store } = this.context;
    const history = syncHistoryWithStore(globalHistory, store);
    const { billingAccountId = null } = this.props;

    return (
      <Router history={history}>
        <Route path='admin'>
          <IndexRoute component={Dashboard} />
          <Route
            path='appointments'
            component={() => <AppointmentListPage />}
          />
          <Route path='saved_searches' component={() => <SavedSearchList />} />
        </Route>

        <Redirect exact from='/setup/communication_plans' to='/setup/communication_plans/applicant' />
        <Route
          path='/setup/activity_items'
          component={() => <ActivityItemsList />}
        />

        <Route
          path='/setup/disputes'
          component={() => <DisputesList />}
        />
        <Route path='/admin/billing'>
          <Route path='billing_dashboard' component={BillingDashboard} />
          <IndexRoute component={StudentsListPage} />
          <Route path='accounts' component={AccountsListPage} />
          <Route path='aging' component={BillingAgingReport} />
          <Route path='ar' component={BillingARReport} />
          <Route path='billing_category_report' component={BillingCategoryReport} />
          <Route path='import' component={BillingImportJobHistory} />
          <Route path='ledger' component={LedgerItemList} />
          <Route path='in_school_payments' component={InSchoolPayments} />
          <Route path='billing_reports' component={BillingReports} />
          <Route path='payouts' component={StripePayoutReport} />
          <Route path='payouts/:payoutId' component={StripePayout} />
          <Route path='projected_income_report' component={ProjectedIncomeReport} />
          <Route path='revenue_recognition_report' component={RevenueRecognitionReport} />
          <Route path='monthly_incremental_report' component={MonthlyIncrementalReport} component={props => <MonthlyIncrementalReport {...props} />} />
        </Route>

        <Route path='/admissions'>
          <Route path='admin_reviews(:school_year_id)' component={props => <CandidatesInReview {...props} />} />
          <Route path='reader_reviews' component={MyReviews} />
        </Route>

        <Route path='/setup/customer_ledger'
          component={CustomerLedger}
        />

        <Route path='/contacts/:contactId'>
          <IndexRoute component={(props) => <Summary contactId={props.params.contactId} />} />
          <Route
            path='billing(/:subPage)'
            component={props => <ContactBillingTab
              contactId={props.params.contactId}
              billingAccountId={billingAccountId}
              subPage={props.params.subPage || 'overview'}
            />}
          />

          <Route path='reviews' component={props => <ReviewTab {...props} />}>
            <IndexRoute component={props => <ReviewCoverSheet {...props} />} />
            <Route path=":reviewId">
              <IndexRoute component={props => <ReviewCoverSheet {...props} />} />
              <Route path="documents/:documentKey" component={props => <ReviewDocument {...props} />} />
              <Route path="test_scores" component={props => <ReviewTestScores {...props} />} />
              <Route path="activities" component={props => <ReviewActivities {...props} />} />
              <Route path="summary" component={props => <ReviewSummary {...props} />} />
            </Route>
          </Route>
        </Route>

        <Route path='/forms_inbox'>
          <IndexRoute component={() => <FormInbox view="default" />} />
          <Route path='/forms_inbox/:view(/:userType)' component={props => <FormInbox {...props.params} />} />
        </Route>

        <Route
          path='internal'
        >
          <Route
            path='delayed_jobs'
            component={props => <DelayedJobs {...props} />}
          />
          <Route
            path='reindex'
            component={props => <Reindex {...props} />}
          />
          <Route path='manage_setup_home' component={props => <ManageSetupHome {...props} />} />
          <Route path='checklist_school_groups' component={props => <ManageChecklistSchoolGroups {...props} />} />
          <Route path='shared_portal_groups' component={props => <ManageSharedPortalGroups {...props} />} />
          <Route path='shared_portal_sherlock_users' component={props => <SharedPortalSherlock {...props} />} />
          <Route path='power_school_contacts(/:studentId)' component={props => <PowerSchoolContacts {...props} />} />
          <Route path='manage_rate_cards' component={props => <ManageRateCards {...props} />} />
        </Route>

        <Route path='reporting'>
          <Route
            path='combined_funnel_report'
            component={CombinedFunnelReport}
          />
          <Route
            path='key_feature_report'
            component={KeyFeatureReport}></Route>

          <Route
            path='combined_enrollment_total_report'
            component={CombinedEnrollmentTotalsReport}
          />
          <Route
            path={'reader_report'}
            component={ReaderReport}
          />

          <Route
            path={'reader_scores_report'}
            component={ReaderScoresReport}
          />

          <Route
            path={'lead_source_report'}
            component={LeadSourceReport}
          />

          <Route
            path={'cross_applicants_report'}
            component={CrossApplicantsReport}
          />
        </Route>

        <Route path='setup'>
          <Route
            path='auth_snippets'
            component={props => <EmailSnippetList filterType={["AuthEmailSnippet"]} {...props} />}
          />
          <Route
            path='blackbaud_sky_config'
            component={BlackbaudSkyConfig}
          />
          <Route
            path='quickbooks_config'
            component={QuickbooksConfig}
          />
          <Route
            path={'billing_categories'}
            component={BillingCategoryPage}
          />
          <Route
            path='billing_config' component={BillingConfigPage}
          />
          <Route
            path='billing_snippets'
            component={props => <EmailSnippetList filterType={["BillingEmailSnippet", "BillingPaymentEmailSnippet"]} {...props} />}
          />
          <Route
            path='bulk_file_workflows'
            component={() => <BulkFileWorkflowsList />}
          />
          <Route
            path='bulk_file_workflows/:id(/:page)'
            component={props => <BulkFileWorkflow bulkFileWorkflowId={props.params.id} page={parseInt(props.params.page, 10) || 0} />}
          />
          <Redirect exact from='communication_plans' to='/setup/communication_plans/applicant' />
          <Route
            path='communication_plans/:workflow'
            component={props => <CommunicationPlanList workflow={props.params.workflow} />}
          />
          <Route
            path='deleted_contacts'
            component={props => <DeletedContactPage {...props} />}
          />
          <Route
            path='email_snippets'
            component={props => <EmailSnippetList filterType={["EmailSnippet"]} {...props} />}
          />
          <Route
            path='export_configs'
            component={props => <ExportConfig {...props} />}
          />
          <Route
            path='fee_management'
            component={() => <FeeManagementPage />}
          />
          <Route
            path='letter_snippets'
            component={props => <LetterSnippetList {...props} />}
          />
          <Route
            path='lotteries'
            component={props => <LotteryConfigurationsIndex {...props} />}
          />
          <Route
            path='list_page_config'
            component={props => <ListPageConfig {...props} />}
          />
          <Route
            path='mailing_label_snippets'
            component={props => <MailingLabelSnippetList {...props} />}
          />
          <Route
            path='mms_histories'
            component={props => <MMSHistory {...props} />}
          />
          <Route
            path='mms_setup'
            component={props => <MMSSetup {...props} />}
          />
          <Route
            path='mms_snippets'
            component={props => <MMSSnippetList {...props} />}
          />
          <Route
            path='oauth'
            component={props => <OAuthConfig {...props} />}
          />
          <Route
            path='gender_config'
            component={props => <GenderConfig {...props} />}
          />
          <Route
            path='payment_plans'
            component={(props) => <PaymentPlanPage {...props} />}
          />
          <Route
            path='admins'
            component={AdminListPage}
          />
          <Route
            path='permission_groups'
            component={GroupListPage}
          />
          <Route
            path='recommendation_snippets'
            component={props => <EmailSnippetList filterType={["RecommendationEmailSnippet", "ChecklistRequestEmailSnippet"]} {...props} />}
          />
          <Redirect from='review' to='review/documents' />
          <Route path='review/:page' component={props => <ReviewSettings {...props} />} />
          <Route
            path='payments'
            component={() => <SAPaymentsSetupPage />}
          />
          <Route
            path='shared_portal_config'
            component={SharedPortalConfig}
          />
          <Route
            path='system_snippets'
            component={props => <EmailSnippetList filterType={["SystemEmailSnippet"]} {...props} />}
          />
          <Route
            path='tags'
            component={TagListPage}
          />
          <Route
            path='widget_snippets'
            component={props => <WidgetSnippetList {...props} />}
          />
          <Route
            path='email_histories'
            component={props => <EmailsList {...props} />}
          />
          <Route
            path='scheduled_emails'
            component={props => <ScheduledEmailsList {...props} />}
          />
          <Route
            path='email_open_rates'
            component={props => <EmailOpenRates {...props} />}
          />
          <Route
            path='payouts'
            component={StripePayoutReport}
          />
          <Route
            path='payouts/:payoutId'
            component={StripePayout}
          />
          <Route
            path='sftp_configs'
            component={props => <SftpListPage {...props} />}
          />
          <Route path="veracross_config" component={() => <VeracrossConfig />} />
          <Route path={'external_api_credentials'} component={ManageExternalApiCredentials} />
          <Route path={'clarity_tuition_config'} component={ClarityTuitionConfig} />
          <Route
            path='api_overview'
            component={ApiOverview}
          />
          <Route
            path='user_jobs'
            component={UserJobPage}
          />
          <Route path='contract_fees' component={ContractFeesList} />
        </Route>

        {parentPortalRoutes()}
      </Router>
    );
  }
}

export default registeredComponent('Routes')(hot(module)(Routes));
